module.exports = __webpack_public_path__ + "img/nodata.13a552b7.png";